import { Checkbox, Collapse } from 'antd';
import { TemplateConfig } from '../../../Templar/RenderPdfPrescription';
import { AntTooltip } from '../../../components/common/AntTooltip';
const { Panel } = Collapse;

const Notes: React.FC<{
    rxConfig: TemplateConfig | undefined;
    saveRxConfigInState: (rxObj: TemplateConfig) => void;
    sectionName?: string;
}> = ({ rxConfig, saveRxConfigInState, sectionName }) => {
    return (
        <Collapse
            expandIcon={() => (
                <div className="rounded-4 min-w-26 h-26 flex items-center justify-center bg-darwin-accent-green-800">
                    <div className="w-full h-full flex items-center justify-center">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-12 h-12 fill-white "
                            viewBox="0 0 12 12"
                            fill="none"
                        >
                            <path d="M10.2889 2.75H4.28887C3.44512 2.75 2.78887 3.42969 2.78887 4.25V10.25C2.76543 11.0938 3.44512 11.75 4.28887 11.75H9.58574C9.79668 11.75 9.98418 11.6797 10.1248 11.5391L11.5545 10.1094C11.6951 9.96875 11.7889 9.78125 11.7889 9.57031V4.25C11.7889 3.42969 11.1092 2.75 10.2889 2.75ZM10.6639 8.75H9.51543C9.11699 8.75 8.76543 9.10156 8.76543 9.5L8.78887 10.625H4.28887C4.07793 10.625 3.91387 10.4609 3.91387 10.25V4.25C3.91387 4.0625 4.07793 3.875 4.28887 3.875H10.2889C10.4764 3.875 10.6639 4.0625 10.6639 4.25V8.75ZM0.538865 8.9375V3.3125C0.538865 1.76562 1.78105 0.5 3.35137 0.5H8.97637C9.28105 0.5 9.53887 0.757812 9.53887 1.0625C9.53887 1.39062 9.28105 1.625 8.97637 1.625H3.35137C2.41387 1.625 1.66387 2.39844 1.66387 3.3125V8.9375C1.66387 9.26562 1.40605 9.5 1.10137 9.5C0.77324 9.5 0.538865 9.26562 0.538865 8.9375Z"></path>
                        </svg>
                    </div>
                </div>
            )}
        >
            <Panel header={<div className="font-700">{sectionName || 'Notes'}</div>} key="1">
                <p className="mr-16 space-y-2">
                    <div className="flex items-center justify-between">
                        <div>Heading</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.notes_heading_color || '#2188FF'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        notes_heading_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            notes_heading_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                    <div className="flex items-center justify-between">
                        <div>Properties</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.notes_properties_color || '#000000'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        notes_properties_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            notes_properties_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                </p>
            </Panel>
        </Collapse>
    );
};

export default Notes;
